<template>
<div class="edit-form-list-item">
  <div class="history-item">
    <div class="history-item-button">
      <div class="button">
        <el-button :disabled="!(index > 0 && length > 1)"
                   icon="el-icon-arrow-up"
                   circle
                   @click.stop="handleCommand('moveUp')"></el-button>
      </div>
      <div class="button">
        <el-button :disabled="!(index + 1 != length && length > 1)"
                   icon="el-icon-arrow-down"
                   circle
                   @click.stop="handleCommand('moveDown')"></el-button>
      </div>
    </div>
    <div class="history-item-content">
      <el-form class="history-form"
               ref="historyItemForm"
               :model="item"
               :rules="rules"
               @submit.native.prevent>
        <div class="history-form-date">
          <el-form-item prop="year">
            <el-input class="input-xs"
                      placeholder="2000"
                      title="年"
                      maxlength="4"
                      v-model="item.year"
                      :min="computedMinYear"
                      :max="computedMaxYear"
                      ref="year">
            </el-input>
            <span>年</span>
          </el-form-item>
          <el-form-item prop="month">
            <el-input class="input-xxs input-2-digit"
                      placeholder="12"
                      title="月"
                      v-model="item.month"
                      type="number"
                      min="1"
                      max="12"
                      ref="month">
            </el-input>
            <span>月</span>
          </el-form-item>
        </div>

        <el-form-item prop="description">
          <el-input class="input-lg"
                    type="textarea"
                    :autosize="{minRows: 1, maxRows: 4}"
                    :placeholder="descriptionPlaceholder"
                    v-model="item.description"
                    ref="desc"></el-input>
        </el-form-item>

        <div class="errors"
             v-if="errors">
          <ul>
            <li v-for="(error, index) in errors"
                :key="index">{{ error }}</li>
          </ul>
        </div>
        <div class="enter text-right">
          <el-button icon="el-icon-delete"
                     @click.stop="handleCommand('delete')">削除</el-button>
          <el-button icon="el-icon-check"
                     @click.stop="$eventHub.$emit('deactivate-history-item')">OK</el-button>
        </div>
      </el-form>
    </div>
  </div>
</div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    },
    length: {
      type: Number
    },
    descriptionPlaceholder: {
      type: String
    },
    descriptionMaxLength: {
      type: Number
    },
    minYear: {
      type: [Number, String]
    },
    maxYear: {
      type: [Number, String]
    }
  },
  data: function () {
    const app = this
    const validateYear = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > 6) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    const validateMonth = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > 4) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    const validateDescription = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > app.descriptionMaxLength) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    return {
      errors: [],
      rules: {
        year: [
          {
            validator: validateYear,
            message: '年が長すぎます',
            trigger: ['change', 'blur']
          }
        ],
        month: [
          {
            validator: validateMonth,
            message: '月が長すぎます',
            trigger: ['change', 'blur']
          }
        ],
        description: [
          {
            validator: validateDescription,
            message: '一行におさまる文字数をオーバーしています。文章を短くするか、行を ＋ で追加して入力してください。',
            trigger: ['change', 'blur']
          }
        ]
      }
    }
  },
  computed: {
    computedMinYear: function () {
      if (this.minYear) {
        return Number(this.minYear)
      }
      return 1900
    },
    computedMaxYear: function () {
      if (this.maxYear) {
        return Number(this.maxYear)
      }
      return new Date().getFullYear() + 3
    }
  },
  methods: {
    handleCommand: function (command) {
      if (command === 'addAbove') {
        this.$emit('add-history-item', this.index)
      } else if (command === 'addBelow') {
        this.$emit('add-history-item', this.index + 1)
      } else if (command === 'delete') {
        this.$emit('delete-history-item', this.index)
      } else if (command === 'duplicate') {
        this.$emit('add-history-item', this.index, this.item)
      } else if (command === 'moveUp') {
        this.$emit('move-history-item', {
          index: this.index,
          to: 'up'
        })
      } else if (command === 'moveDown') {
        this.$emit('move-history-item', {
          index: this.index,
          to: 'down'
        })
      }
    },
    resizeDesc: function () {
      const app = this
      this.$nextTick(function () {
        if (typeof app.$refs['desc'].resizeTextarea === 'function') {
          // 表示されているか確認する
          if (app.$refs['desc'].$el.offsetHeight) {
            app.$refs['desc'].resizeTextarea()
          }
        }
      })
    }
  },
  beforeMount: function () {
    this.$nextTick(function () {
      // 初回読み込み時にバリデーションを動かす
      this.$refs['historyItemForm'].validate().then().catch(function (e) {
        // console.error(e)
      })
    })
  },
  mounted: function () {
    // 表示されていない要素だとリサイズが走らないので、カード変更のタイミングで実行する
    this.$eventHub.$on('card-changed', this.resizeDesc)
  },
  destroyed: function () {
    this.$eventHub.$off('card-changed', this.resizeDesc)
  }
}
</script>
